import React from "react";
import {
  CheckCircleFill,
  ExclamationTriangleFill,
  InfoCircleFill,
  XCircleFill,
} from "react-bootstrap-icons";
import { cn } from "../../lib/cn";

export type AlertTone = "info" | "success" | "warning" | "danger";

const TONES: Record<AlertTone, { wrapper: string; Icon: typeof InfoCircleFill }> = {
  info: { wrapper: "bg-accent-soft text-accent", Icon: InfoCircleFill },
  success: { wrapper: "bg-success-soft text-success", Icon: CheckCircleFill },
  warning: { wrapper: "bg-warning-soft text-warning", Icon: ExclamationTriangleFill },
  danger: { wrapper: "bg-danger-soft text-danger", Icon: XCircleFill },
};

export function Alert({
  tone = "info",
  title,
  children,
  className,
}: {
  tone?: AlertTone;
  title?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}) {
  const { wrapper, Icon } = TONES[tone];

  return (
    <div
      role={tone === "danger" ? "alert" : "status"}
      className={cn(
        "animate-fade-in flex items-start gap-2.5 rounded-lg px-3.5 py-3 text-[13px]",
        wrapper,
        className,
      )}
    >
      <Icon size={14} aria-hidden="true" className="mt-0.5 shrink-0" />
      <div className="min-w-0 leading-relaxed">
        {title && <p className="font-semibold">{title}</p>}
        {children && (
          <div className={cn(Boolean(title) && "mt-0.5", "opacity-90")}>{children}</div>
        )}
      </div>
    </div>
  );
}

export default Alert;
